//This component is currently designed to fill in the gaps of horizontally arranged lists. 
//The divs will expand when marked as visible, which will in turn make the list items smoothly expand out and in.

import React from 'react';
import { animated, useSpring, config } from '@react-spring/web'

//Can always update this out more to make it flexible.
interface IExpandingDivProps {
    visible: boolean;
    startWidth: number;
    targetWidth: number;
    children?: Element;
}

const ExpandingDiv: React.FunctionComponent<IExpandingDivProps> = props => {
    const springStyle = useSpring({
        width: props.visible ? 100 : 0,
        height: 100,
        backgroundColor: "transparent",
        config: config.default
    });

    return (
    <animated.div
        style={springStyle}
    >
        {props.children}
    </animated.div>);
}

export default ExpandingDiv;